import RemoveButtonCoreUI from './RemoveButtonCoreUI';

export default RemoveButtonCoreUI;
